import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Select from "react-select";
import { privateRequest } from "../commonApi/CommonApi";
import Swal from "sweetalert2";

import { Helmet } from "react-helmet";

function FaqQuestion() {
  const [banner, setBanner] = useState([]);

  const [selectedStatus, setSelectedStatus] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [parentCategory, setParentCategoryGroups] = useState([]);

  const getFaqQuestion = async () => {
    try {
      const response = await privateRequest.get("/Faqs/GetFaqs");
      setBanner(response?.data?.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const getParentCategory = async () => {
    try {
      const response = await privateRequest.get(
        `ParentCategory/Parentcategory`
      );
      setParentCategoryGroups(response?.data?.Data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const DeleteBanner = async (_id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this item!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
        closeOnConfirm: false,
        closeOnCancel: true,
      });

      if (result.isConfirmed) {
        const response = await privateRequest.delete(
          `Faqs/Deleteparentdata/${_id}`
        );
        getFaqQuestion();
        Swal.fire("Deleted!", "Your item has been deleted.", "success");
      } else {
        Swal.fire(
          "Cancelled",
          "Your item deletion has been cancelled.",
          "info"
        );
      }
    } catch (error) {
      console.error("DELETE Error:", error);
      Swal.fire("Error!", "Failed to delete item.", "error");
    }
  };
  const Delete = async (parentId, faqId) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this item!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
        closeOnConfirm: false,
        closeOnCancel: true,
      });

      if (result.isConfirmed) {
        const response = await privateRequest.delete(
          `Faqs/DeleteFaqs/${parentId}/${faqId}`
        );
        getFaqQuestion();
        Swal.fire("Deleted!", "Your item has been deleted.", "success");
      } else {
        Swal.fire(
          "Cancelled",
          "Your item deletion has been cancelled.",
          "info"
        );
      }
    } catch (error) {
      console.error("DELETE Error:", error);
      Swal.fire("Error!", "Failed to delete item.", "error");
    }
  };

  const AddBrandweuse = async (event) => {
    event.preventDefault();

    try {
      const formData = new FormData();
      formData.append("Status", selectedStatus);
      formData.append("PCatID", selectedGroup.value);
      formData.append("Question", selectedGroup.value);
      formData.append("Answer", selectedGroup.value);
      formData.append("Status", selectedStatus);

      let response;
      if (selectedItem._id) {
        response = await privateRequest.put(
          `/BrandWeUse/UpdateBrandWeUse/${selectedItem._id}`,
          formData
        );
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Brand logos updated successfully!",
        });
      } else {
        response = await privateRequest.post(
          "/BrandWeUse/CreateBrandWeUse",
          formData
        );
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Brand logos added successfully!",
        });
      }

      console.log("POST Response:", response);
      getFaqQuestion();
      setShowModal(false);

      setSelectedStatus("");
      setSelectedItem({});
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Failed to update/insert brand logos.",
      });
    }
  };

  useEffect(() => {
    getFaqQuestion();
    getParentCategory();
  }, []);

  return (
    <>
      {banner.length > 0 && (
        <Helmet>
          <script>new DataTable("#my_table");</script>
        </Helmet>
      )}
      <div className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex flex-column flex-md-row">
                    <p className="lead mb-0">
                      <span className="font-weight-bold">
                        Faq Question/Answer
                      </span>
                    </p>
                    <button
                      className="btn btn-primary btn-sm ml-auto"
                      onClick={() => setShowModal(true)}
                    >
                      <i className="fa fa-plus mr-2"></i>Add New
                    </button>
                  </div>
                </header>
                <div className="page-section">
                  <div className="card">
                    <div className="card-body table-responsive">
                      <table
                        id="my_table"
                        className="table table-striped table-hover table-sm no-footer text-center"
                      >
                        <thead className="bg-primary text-white">
                          <tr>
                            <th scope="col">Sr No</th>
                            <th scope="col">Question</th>
                            <th scope="col">Answer</th>
                            <th scope="col">Delete</th>
                            <th scope="col">PCName</th>
                            <th scope="col">Status</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {banner?.map((item, index) =>
                            item.Faqs.map((faq, faqIndex) => (
                              <tr key={index + "_" + faqIndex}>
                                <td className="align-center">{index + 1}</td>
                                <td className="align-center">{faq.Question}</td>
                                <td className="align-center">{faq.Ans}</td>
                                <button
                                  className="btn btn-danger btn-sm"
                                  onClick={() => Delete(item._id)}
                                >
                                  <i className="fa fa-trash"></i>
                                </button>
                                {faqIndex === 0 && (
                                  <td
                                    className="align-center"
                                    rowSpan={item.Faqs.length}
                                  >
                                    {item?.PCatID?.PCName}
                                  </td>
                                )}
                                {faqIndex === 0 && (
                                  <td rowSpan={item.Faqs.length}>
                                    <span
                                      className={`badge ${
                                        item?.status.toString() === "active"
                                          ? "badge-primary"
                                          : "badge-danger"
                                      }`}
                                    >
                                      {item?.status.toString() === "active"
                                        ? "Active"
                                        : "Inactive"}
                                    </span>
                                  </td>
                                )}
                                {faqIndex === 0 && (
                                  <td
                                    className="align-center"
                                    rowSpan={item.Faqs.length}
                                  >
                                    <div className="btn-group">
                                      <button
                                        className="btn btn-primary btn-sm"
                                        onClick={() => {
                                          setSelectedItem(item);
                                          setSelectedGroup(item.PCName);
                                          setSelectedStatus(
                                            item.status ? "1" : "0"
                                          );
                                          setShowModal(true);
                                        }}
                                      >
                                        <i className="fa fa-edit"></i>
                                      </button>
                                      <button
                                        className="btn btn-danger btn-sm"
                                        onClick={() => DeleteBanner(item._id)}
                                      >
                                        <i className="fa fa-trash"></i>
                                      </button>
                                    </div>
                                  </td>
                                )}
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* All Modals */}
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        id="addHeroSliderModal"
        tabIndex="-1"
        role="dialog"
        style={{ display: showModal ? "block" : "none" }}
      >
        <div
          className="modal-dialog  modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Faq Question/Answer
              </h5>
              <button
                type="button"
                className="close"
                onClick={() => setShowModal(false)}
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={AddBrandweuse}>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label className="mb-0">Select P Cat</label>
                      <Select
                        isClearable
                        options={parentCategory.map((group) => ({
                          value: group._id,
                          label: group.PCName,
                        }))}
                        onChange={(selectedOption) =>
                          setSelectedGroup(selectedOption)
                        }
                        value={selectedGroup}
                      />
                    </div>
                  </div>{" "}
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label className="mb-0">Status</label>
                      <select
                        className="form-control"
                        value={selectedStatus}
                        onChange={(e) => setSelectedStatus(e.target.value)}
                      >
                        <option value="">Select</option>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>
                  </div>
                </div>
                <hr className="mt-0" />

                <div className="row">
                  <div className="col-lg-12">
                    <div className="form-group text-left">
                      <button type="submit" className="btn btn-primary">
                        {selectedItem._id ? "Update" : "Submit"}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {showModal && <div className="modal-backdrop fade show"></div>}
    </>
  );
}

export default FaqQuestion;
